import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);

export const searchLeads = ({ industry, city, state, page, emailOnly, dedupe }) =>
  axios
    .get(`${API}/search`, {
      params: { industry, city, state, page, email_only: !!emailOnly, dedupe: !!dedupe },
    })
    .then((r) => r.data);

export const resetSeen = () => axios.delete(`${API}/seen`).then((r) => r.data);
export const getSeenCount = () => axios.get(`${API}/seen/count`).then((r) => r.data);

export const getInstantlyCampaigns = () =>
  axios.get(`${API}/instantly/campaigns`).then((r) => r.data);
export const pushToInstantly = (campaignId, leads) =>
  axios.post(`${API}/instantly/push`, { campaign_id: campaignId, leads }).then((r) => r.data);
export const getPushSummary = () =>
  axios.get(`${API}/instantly/push-summary`).then((r) => r.data);

export const getSettings = () => axios.get(`${API}/settings`).then((r) => r.data);
export const saveSettings = (s) => axios.put(`${API}/settings`, s).then((r) => r.data);

export const getPresets = () => axios.get(`${API}/presets`).then((r) => r.data);
export const savePreset = (p) => axios.post(`${API}/presets`, p).then((r) => r.data);
export const deletePreset = (id) => axios.delete(`${API}/presets/${id}`).then((r) => r.data);

export const getBlocklist = () => axios.get(`${API}/blocklist`).then((r) => r.data);
export const addBlock = (value, type) => axios.post(`${API}/blocklist`, { value, type }).then((r) => r.data);
export const deleteBlock = (id) => axios.delete(`${API}/blocklist/${id}`).then((r) => r.data);

export const getDigest = () => axios.get(`${API}/digest`).then((r) => r.data);
export const getDigestConfig = () => axios.get(`${API}/digest/config`).then((r) => r.data);
export const sendTestDigest = () => axios.post(`${API}/digest/send-test`).then((r) => r.data);

const DEFAULT_SETTINGS = {
  address_var: "address", rating_var: "rating", reviews_var: "reviews",
  include_address: true, include_rating: true, include_reviews: true,
};

export const getHistory = () => axios.get(`${API}/history`).then((r) => r.data);

export const saveList = (name, leads) =>
  axios.post(`${API}/lists`, { name, leads }).then((r) => r.data);

export const getLists = () => axios.get(`${API}/lists`).then((r) => r.data);
export const getList = (id) => axios.get(`${API}/lists/${id}`).then((r) => r.data);
export const deleteList = (id) => axios.delete(`${API}/lists/${id}`).then((r) => r.data);

// CSV formatted for Instantly.ai bulk import, honoring the saved field mapping.
// Instantly auto-recognizes: email, first_name, last_name, company_name, phone, website.
// Included extras (address/rating/reviews) use the custom variable names from settings.
export function leadsToCSV(leads, settings = DEFAULT_SETTINGS) {
  const s = { ...DEFAULT_SETTINGS, ...(settings || {}) };
  const headers = ["email", "first_name", "last_name", "company_name", "phone", "website"];
  const extras = [];
  if (s.include_address) extras.push({ key: s.address_var, get: (l) => l.address });
  if (s.include_rating) extras.push({ key: s.rating_var, get: (l) => l.rating });
  if (s.include_reviews) extras.push({ key: s.reviews_var, get: (l) => l.reviews });
  const allHeaders = [...headers, ...extras.map((e) => e.key)];

  const escape = (v) => `"${(v ?? "").toString().replace(/"/g, '""')}"`;
  const rows = leads.map((l) => {
    const email = l.email || (l.emails || [])[0] || "";
    const base = [email, l.first_name || "", "", l.name, l.phone, l.website];
    const ex = extras.map((e) => e.get(l));
    return [...base, ...ex].map(escape).join(",");
  });
  return [allHeaders.join(","), ...rows].join("\n");
}

export function downloadCSV(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
